"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _Translator = require("../../Core/Translator");
var _common = require("../common");
var _getFilteredPlanData = require("./getFilteredPlanData");
var _DevicePlans = require("../../DevicePlans");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Device = require("../../Device");
var _getDateText = require("./getDateText");
var _Time = require("../../Time");
var _Theme = require("../../Theme");
var _ComponentRemainingLifeValue = require("./ComponentRemainingLifeValue");
var _Utils = require("../../../Utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ComponentRemainingLifeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementlegacy__ComponentRemainingLifeWrapper",
  componentId: "sc-r2gcl8-0"
})(["background-color:", ";"], function (props) {
  return (0, _Theme.val)((0, _getFilteredPlanData.getBackgroundColor)(props.remainingLife));
});
var NoDataTextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ComponentRemainingLifeElementlegacy__NoDataTextWrapper",
  componentId: "sc-r2gcl8-1"
})(["display:flex;justify-content:center;align-items:center;font-size:", ";"], (0, _Theme.val)("fontSizeLarge"));
var getRemainingLifeValue = function getRemainingLifeValue(threshold, fontSize, remainingLife) {
  return threshold !== 0 ? Math.round(remainingLife) + " %" : "-";
};
var ComponentRemainingLifeElement = exports.ComponentRemainingLifeElement = function ComponentRemainingLifeElement(props) {
  var hidePlanName = props.hidePlanName,
    hideCumulativeUsage = props.hideCumulativeUsage,
    hideRemainingLife = props.hideRemainingLife,
    hideLastClosedMaintenanceDate = props.hideLastClosedMaintenanceDate,
    hideMaintenancePredictedOrDueDate = props.hideMaintenancePredictedOrDueDate,
    width = props.width,
    height = props.height,
    fontSize = props.fontSize;
  var _React$useContext = _react["default"].useContext(_DevicePlans.DevicePlansContext),
    getDevicePlansData = _React$useContext.getDevicePlansData;
  var device = _react["default"].useContext(_Device.DeviceContext);
  var _React$useContext2 = _react["default"].useContext(_Time.TimeContext),
    timezone = _React$useContext2.timezone;
  var _React$useContext3 = _react["default"].useContext(_Time.ReportingPeriodContext),
    name = _React$useContext3.name;
  var _React$useContext4 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext4.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: getDevicePlansData,
    params: device.uuid,
    key: name
  }, function (loaderProps) {
    return /*#__PURE__*/_react["default"].createElement(_Core.LoadingMediator, loaderProps, function (data) {
      if (data.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(NoDataTextWrapper, _extends({
          style: Object.assign({}, (0, _common.getWidgetPositionProps)(props))
        }, (0, _common.getWidgetInteractionProps)(props), {
          "data-testid": "ComponentRemainingLifeNoDataText"
        }), translate("ComponentRemainingLife.NoData.HelperText", "No plans exist for this device"));
      }
      var eachComponentHeightDivision = [hidePlanName, hideCumulativeUsage, hideRemainingLife, hideLastClosedMaintenanceDate, hideMaintenancePredictedOrDueDate].filter(function (value) {
        return !value;
      }).length;
      var planData = (0, _getFilteredPlanData.getFilteredPlanData)(data);
      var planName = planData.planName,
        remainingLife = planData.remainingLife,
        threshold = planData.threshold,
        currentValue = planData.currentValue;
      return /*#__PURE__*/_react["default"].createElement(ComponentRemainingLifeWrapper, _extends({
        remainingLife: remainingLife,
        style: (0, _common.getWidgetPositionProps)(props)
      }, (0, _common.getWidgetInteractionProps)(props), {
        "data-testid": "ComponentRemainingLife"
      }), hidePlanName ? null : /*#__PURE__*/_react["default"].createElement(_ComponentRemainingLifeValue.ComponentRemainingLifeValue, {
        width: width,
        totalHeight: height,
        eachComponentHeightDivision: eachComponentHeightDivision,
        fontSize: fontSize,
        value: planName,
        label: translate("ComponentRemainingLife.PlanName.Label", "Plan Name")
      }), hideRemainingLife ? null : /*#__PURE__*/_react["default"].createElement(_ComponentRemainingLifeValue.ComponentRemainingLifeValue, {
        width: width,
        totalHeight: height,
        eachComponentHeightDivision: eachComponentHeightDivision,
        fontSize: fontSize,
        value: getRemainingLifeValue(threshold, fontSize, remainingLife),
        label: translate("ComponentRemainingLife.RemainingLife.Label", "Remaining Life"),
        dataTestId: "ComponentRemainingLife.RemainingLife"
      }), hideCumulativeUsage ? null : /*#__PURE__*/_react["default"].createElement(_ComponentRemainingLifeValue.ComponentRemainingLifeValue, {
        width: width,
        totalHeight: height,
        eachComponentHeightDivision: eachComponentHeightDivision,
        fontSize: fontSize,
        value: (0, _Utils.formatDuration)(currentValue),
        label: translate("ComponentRemainingLife.CumulativeUsage.label", "Cumulative usage since last task closed")
      }), hideMaintenancePredictedOrDueDate ? null : /*#__PURE__*/_react["default"].createElement(_ComponentRemainingLifeValue.ComponentRemainingLifeValue, {
        width: width,
        totalHeight: height,
        eachComponentHeightDivision: eachComponentHeightDivision,
        fontSize: fontSize,
        value: (0, _getDateText.getDateText)(planData, timezone.name),
        label: translate("ComponentRemainingLife.MaintenancePredictedOrDueDate.label", "Predicted/Pending Date"),
        dataTestId: "ComponentRemainingLife.MaintenancePredictedOrDueDate"
      }), hideLastClosedMaintenanceDate ? null : /*#__PURE__*/_react["default"].createElement(_ComponentRemainingLifeValue.ComponentRemainingLifeValue, {
        width: width,
        totalHeight: height,
        eachComponentHeightDivision: eachComponentHeightDivision,
        fontSize: fontSize,
        value: (0, _getDateText.getLastClosedMaintenanceTaskDate)(planData, timezone.name),
        label: translate("ComponentRemainingLife.LastClosedMaintenanceDate.label", "Last closed maintenance task date"),
        dataTestId: "ComponentRemainingLife.LastClosedMaintenanceDate"
      }));
    });
  });
};